import React from 'react';
import Row from '../Symbols/Row';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import InputSelect from '../Symbols/InputSelect';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import { dismissalTypeOptions } from './Options';

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { income, dismissalType, age },
		uec = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka - podpora v nezaměstnanosti 2018">
				<InputCurrency
					label="Průměrná čistá měsíční mzda za předchozí kalendářní čtvrtletí"
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					value={income}
					name="income"
					error={errors.income}
				/>

				<InputSelect
					label="Kdo dal výpověď?"
					onChange={changeHandler('dismissalType')}
					onBlur={validateHandler('dismissalType')}
					value={dismissalType}
					name="dismissalType"
					select={dismissalTypeOptions}
					error={errors.dismissalType}
				/>

				<Input
					type="number"
					label="Jaký je váš věk"
					onChange={changeHandler('age')}
					onBlur={validateHandler('age')}
					value={age}
					name="age"
					error={errors.age}
				/>

				<div css={Row}>
					<Button>Výpočet</Button>
				</div>

				{uec && <Result uec={uec} />}
				{uec && (
					<div css={Row}>
						<Button onClick={reset}>Nový výpočet</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
